import { render, staticRenderFns } from "./CameraCard.vue?vue&type=template&id=63f58b20"
import script from "./CameraCard.vue?vue&type=script&lang=ts"
export * from "./CameraCard.vue?vue&type=script&lang=ts"
import style0 from "./CameraCard.vue?vue&type=style&index=0&id=63f58b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports